export default function TermsOfService() {
    return (
        <main>
            <section className="">
                <h1>Условия использования</h1>
                <p>
                    Пользовательское Соглашение
                    Настоящее Пользовательское Соглашение (Далее Соглашение) регулирует отношения между владельцем dariazherebtsova.ru (далее dariazherebtsova.ru или Администрация) с одной стороны и пользователем сайта с другой.<br></br>
                    Сайт dariazherebtsova.ru не является средством массовой информации.<br></br><br></br>

                    Используя сайт, Вы соглашаетесь с условиями данного соглашения.
                    Если Вы не согласны с условиями данного соглашения, не используйте сайт dariazherebtsova.ru!<br></br><br></br>

                    Права и обязанности сторон<br></br><br></br>
                    Пользователь имеет право:<br></br>
                    - осуществлять поиск информации на сайте<br></br>
                    - получать информацию на сайте<br></br>
                    - использовать информацию сайта в личных некоммерческих целях<br></br><br></br>

                    Администрация имеет право:<br></br>
                    - по своему усмотрению и необходимости создавать, изменять, отменять правила<br></br>
                    - ограничивать доступ к любой информации на сайте<br></br>
                    - создавать, изменять, удалять информацию<br></br><br></br>

                    Пользователь обязуется:<br></br>
                    - не нарушать работоспособность сайта<br></br>
                    - не использовать скрипты (программы) для автоматизированного сбора информации и/или взаимодействия с Сайтом и его Сервисами<br></br><br></br>

                    Администрация обязуется:<br></br>
                    - поддерживать работоспособность сайта за исключением случаев, когда это невозможно по независящим от Администрации причинам.<br></br><br></br>

                    Ответственность сторон<br></br>
                    - пользователь лично несет полную ответственность за распространяемую им информацию<br></br>
                    - администрация не несет никакой ответственности за достоверность информации, скопированной из других источников<br></br>
                    - администрация не несёт ответственность за несовпадение ожидаемых Пользователем и реально полученных услуг<br></br>
                    - администрация не несет никакой ответственности за услуги, предоставляемые третьими лицами<br></br>
                    - в случае возникновения форс-мажорной ситуации (боевые действия, чрезвычайное положение, стихийное бедствие и т. д.) Администрация не гарантирует сохранность информации, размещённой Пользователем, а также бесперебойную работу информационного ресурса<br></br><br></br>

                    Условия действия Соглашения<br></br>
                    Данное Соглашение вступает в силу при любом использовании данного сайта.<br></br>
                    Соглашение перестает действовать при появлении его новой версии.<br></br>
                    Администрация оставляет за собой право в одностороннем порядке изменять данное соглашение по своему усмотрению.<br></br>
                    Администрация не оповещает пользователей об изменении в Соглашении.
                </p>
            </section>
        </main>
    );
}